export const BUSINESS = {
  name: "Blossom Spa Madhapur",
  shortName: "Blossom Spa",
  phone: "+91 7330619409",
  phoneClean: "+917330619409",
  phoneDisplay: "+91 73306 19409",
  address:
    "Pillar No. 1743, Gem Square Building, Metro Station, Plot No. 1-88/2 1st Floor, near Durgam Cheruvu, above HDFC Bank, Madhapur, Telangana 500081",
  addressShort: "Madhapur, Hyderabad, Telangana 500081",
  landmark: "Near Durgam Cheruvu Metro Station, above HDFC Bank",
  city: "Hyderabad",
  website: "https://blossomspa.in/",
  mapsEmbedSrc:
    "https://www.google.com/maps?q=Gem+Square+Building+Madhapur+Hyderabad+Telangana+500081&output=embed",
  mapsDirectionsUrl:
    "https://www.google.com/maps/search/?api=1&query=" +
    encodeURIComponent(
      "Gem Square Building, Plot No. 1-88/2, Madhapur, Hyderabad, Telangana 500081"
    ),
};
